export class CodaBoxDocument {
	ID: number = 0;
	DocumentType: string = "";
	FeedIndex: string = "";
	Status: string = "";
	FileID: number = 0;
	IBAN: string = "";
	StatementNr: string = "";
	BalanceDate: string = "";
	FetchedAt: string = "";
	ProcessedAt: string | null = null;

	public constructor(data?: any) {
		if (!data) return;
		this.ID = data.ID || 0;
		this.DocumentType = data.DocumentType || "";
		this.FeedIndex = data.FeedIndex || "";
		this.Status = data.Status || "";
		this.FileID = data.FileID || 0;
		this.IBAN = data.IBAN || "";
		this.StatementNr = data.StatementNr || "";
		this.BalanceDate = data.BalanceDate || "";
		this.FetchedAt = data.FetchedAt || "";
		this.ProcessedAt = data.ProcessedAt || null;
	}

	get isCoda(): boolean {
		return this.DocumentType === "coda";
	}

	get isSoda(): boolean {
		return this.DocumentType === "soda";
	}

	get isPending(): boolean {
		return this.Status === "pending";
	}
}
